import React from 'react';
import { connect, } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actions as rootActions } from '../actions'
import { NAME as ROOT_NAME } from '../../Root/reducer'
import { isSaving } from '../../Root/saving'
import { NON_NEGATIVE, nonNegativeChange } from '../../Root/nonNegative'
import { NAME as MONITOR_NAME } from '../reducer'
import { actions as productTypeActions} from '../../ProductType/actions';
import { NAME as PRODUCT_TYPE} from '../../ProductType/reducer'
import { Button, TextField } from '@material-ui/core'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import Autocomplete from "@mui/material/Autocomplete";

import { withStyles } from "@material-ui/core/styles";


function mapStateToProps(state) {
  return {
    ...state[MONITOR_NAME],
    productTypeList: state[PRODUCT_TYPE].productTypeList,
    saving: isSaving(state[ROOT_NAME], 'MONITOR_CREATE')
  }
}

const styles = (theme) => ({
  autocomplete: {
    height: "100%",
    "& .MuiAutocomplete-root": {
      height: "100%",
    },
    "& .MuiTextField-root": {
      height: "100%",
    },
    "& .MuiAutocomplete-inputRoot": {
      height: "100%",
    },
    "& .MuiFormControl-root": {
      height: "100%",
    }
  },
  button: {
    height: "100%",
    "& .MuiFormControl-root": {
      height: "100%"
    },
    "& .MuiButtonBase-root": {
      height: "100%"
    }
  }
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...rootActions,
  getProductTypeList: productTypeActions.getProductTypeList,
}, dispatch)

function validate(selector){
  let successFlag = 0
  //name validation
  if (!selector.state.name) {
    selector.setState({ errorName: true, helperTextName: "Введите название." })
    successFlag--
  } else {
    selector.setState({ errorName: false, helperTextName: "" })
    successFlag++
  }
  //shipping Conditions validation
  if (!selector.state.shippingConditions) {
    selector.setState({ errorShippingConditions: true, helperTextShippingConditions: "Поле должно быть заполнено." })
    successFlag--
  } else {
    selector.setState({ errorShippingConditions: false, helperTextShippingConditions: "" })
    successFlag++
  }
  //price validation
  if (!selector.state.price) {
    selector.setState({ errorPrice: true, helperTextPrice: "Введите цену." })
    successFlag--
  } else {
    selector.setState({ errorPrice: false, helperTextPrice: "" })
    successFlag++
  }

  // let rowsValid = true;
  // const updatedRows = selector.state.rows.map((row) => {
  //   let rowError = false;

  //   if (!row.product_id) {
  //     rowError = true;
  //     rowsValid = false;
  //   } else if (!row.price || row.price <= 0) {
  //     rowError = true;
  //     rowsValid = false;
  //   }

  //   return {
  //     ...row,
  //     error: rowError,
  //   };
  // });

  // // Оновлення стану, якщо знайдені помилки
  // if (!rowsValid) {
  //   selector.setState({ rows: updatedRows });
  //   successFlag--;
  // } else {
  //   successFlag++;
  // }

  if (successFlag === 3) { return true }
}

class CreateMonitor extends React.Component {
  constructor(props) {
    super(props);
    //props.getMonitorsList()
    this.state = {
      errorName: false,
      errorShippingConditions: false,
      errorPrice: false,

      helperTextName: "",
      helperTextShippingConditions: "",
      helperTextPrice: "",

      rows: [{ id: Date.now(), product_id: '', price: '', error: false }],
      showFields: false
    }
  }

  componentDidMount() {
    console.log('rows: ', this.state.rows)
    this.props.getProductTypeList();
  }

  toggleFields = () => {
    this.setState((prevState) => ({ showFields: !prevState.showFields }));
  };

  addRow = () => {
    this.setState((prevState) => ({
      rows: [...prevState.rows, { id: Date.now(), value: "" }],
    }));
  };

  removeRow = (id) => {
    this.setState((prevState) => ({
      rows: prevState.rows.filter((row) => row.id !== id),
    }));
  };

  handleValueChange = (id, field, value) => {
    this.setState((prevState) => ({
      rows: prevState.rows.map((row) =>
        row.id === id ? { ...row, [field]: value, error: false } : row
      ),
    }));
  };

  // handleSave = () => {
  //   let hasError = false;
  //   const updatedRows = this.state.rows.map((row) => {
  //     if (!row.product_id || !row.price) {
  //       hasError = true;
  //       return { ...row, error: true };
  //     }
  //     return row;
  //   });
    
  //   if (hasError) {
  //     this.setState({ rows: updatedRows });
  //   } else {
  //     const products = this.state.rows.map(row => ({
  //       product_id: row.product,
  //       price: row.price
  //     }));
  //   }
  // };

  handleCancel = () => {
    this.setState({ rows: [{ id: Date.now(), product_id: '', price: '', error: false }], showFields: false });
    console.log('updated rows: ', this.state.rows)
  };


  render() {
    const { classes } = this.props;

    return (
      <Grid component={Paper} container spacing={3}>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextField
              id="warehouseName"
              label="Название склада"
              variant="outlined"
              error={this.state.errorName}
              helperText={this.state.helperTextName}
              onChange={e => this.setState({ name: e.target.value, errorName: false, helperTextName: "" })}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextField
              id="deliveryCondition"
              label="Условия доставки"
              variant="outlined"
              error={this.state.errorShippingConditions}
              helperText={this.state.helperTextShippingConditions}
              onChange={e => this.setState({ shippingConditions: e.target.value, errorShippingConditions: false, helperTextShippingConditions: "" })}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextField
              id="price"
              label="Цена"
              inputProps={NON_NEGATIVE}
              variant="outlined"
              type = "number"
              error={this.state.errorPrice}
              helperText={this.state.helperTextPrice}
              InputProps={{
                endAdornment: <InputAdornment position="end">Грн.</InputAdornment>
              }}
              onChange={nonNegativeChange(e => this.setState({ price: e.target.value, errorPrice: false, helperTextPrice: "" }))}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextField
              id="notice"
              label="Заметки"
              variant="outlined"
              onChange={e => this.setState({ description: e.target.value })}
            />
          </FormControl>
        </Grid>

        <Grid  item xs={12}/* Add Button section */>
          <Grid container spacing={3}>
            <Grid item sm={6}>
                <FormControl fullWidth>
                  <Button 
                    variant='outlined' 
                    color='primary'
                    onClick={this.toggleFields}
                    >
                    Добавить культуру
                  </Button>
                </FormControl>
            </Grid>
          </Grid>
        </Grid>
        
        {this.state.showFields && 
          this.state.rows.map((row) => (
          <Grid item xs={12} key={row.id}>
            <Grid container spacing={3}>
              <Grid item sm={7}>
              <FormControl fullWidth className={classes.autocomplete}>
                <Autocomplete 
                  openText="Открыть список"
                  closeText="Закрыть список"
                  clearText="Очистить"
                  options={this.props.productTypeList.filter(
                    (option) => !this.state.rows.some(row => row.product_id === option.id) || row.product_id === option.id
                  )} // A filter to exclude previously selected options
                  getOptionLabel={(option) => option.name}
                  value={this.props.productTypeList.find(p => p.id === row.product_id) || null}
                  onChange={(event, newValue) => this.handleValueChange(row.id, 'product_id', newValue ? newValue.id : '')}
                  renderInput={(params) => (
                    <TextField {...params} label="Добавить культуру" variant="outlined"
                      error={row.error && !row.product_id}
                      helperText={row.error && !row.product_id ? "Поле обязательно" : ''}
                    />
                  )}
                />
              </FormControl>      
              </Grid>
              <Grid item sm={3}>
                <TextField 
                  fullWidth 
                  label="Цена"
                  inputProps={NON_NEGATIVE}
                  type='number'
                  variant="outlined"
                  value={row.price ?? 0}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Грн.</InputAdornment>
                  }}
                  onChange={nonNegativeChange((e) => {
                    const newValue = parseFloat(e.target.value);
    
                    if (!isNaN(newValue) && newValue >= 0) {
                      this.handleValueChange(row.id, "price", newValue);
                    } else {
                      this.handleValueChange(row.id, "price", "");
                    }
                  })}
                error={row.error && (row.price === "" || row.price < 0)}
                helperText={row.error && (row.price === "" || row.price < 0)  ? "Поле обязательно" : ''}
                  // error={row.error && !row.price}
                  // helperText={row.error && !row.price ? "Поле обязательно" : ''} 
                />
              </Grid>
              <Grid item sm={2}>
                <FormControl fullWidth className={classes.button}>
                  <Button 
                    variant='outlined' 
                    color='secondary'
                    size='large'
                    disabled={this.state.rows.length === 1}
                    onClick={() => this.removeRow(row.id)}
                  >
                  Удалить
                  </Button>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        ))}
        
        {this.state.showFields && (
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="space-between">
              <Grid item xs={6}>
                <Button size='large' variant="contained" fullWidth onClick={this.addRow}>
                  + Добавить ещё культуру
                </Button>
              </Grid>
              {/* <Grid item xs={2}>
                <Button size='large' variant="contained" fullWidth onClick={this.handleSave}>
                  Сохранить
                </Button>
              </Grid> */}
              <Grid item xs={4}>
                <Button size='large' variant="contained" fullWidth onClick={this.handleCancel}>
                  Очистить список культур
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}        
        <Grid item xs={12}>
          <FormControl fullWidth>
            <Button variant="contained" color="primary" disabled={this.props.saving} onClick={() => {          
              if(validate(this)){
                this.props.createMonitor({
                name: this.state.name,
                shippingConditions: this.state.shippingConditions,
                price: this.state.price,
                description: this.state.description,
                products: this.state.rows.map(row => ({
                  product: row.product_id,
                  price: row.price,
                })) 
              })
              }
            }}>Создать монитор</Button>
          </FormControl>
        </Grid>       
      </Grid>
    )
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CreateMonitor));
